import { TIMERS } from '../constants/timers';
import { checkVisitorId } from './check-visitor-id';

type Item = {
  value: string;
  expiry: number;
};

export const setItemWithExpiry = (key: string, value: string): void => {
  const now = new Date();

  const item: Item = {
    value,
    expiry: now.getTime() + TIMERS.LOCAL_STORAGE_SAVE,
  };

  localStorage.setItem(key, JSON.stringify(item));
};

export const getItemWithExpiry = (key: string): string | null => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  if (checkVisitorId(itemStr)) {
    return itemStr;
  }

  const item: Item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);

    return null;
  }

  return item.value;
};
